import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import { SearchInput } from '@/views/components/inputs';

// Types
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import { truncateString } from '@/utils/objects';

type ContactDetailsOmniRiskProfileHeaderProps = {
  firstName?: string;
  omniRiskProfiles: FormattedFullOmniRiskProfile[];
  query: string;
  searching: boolean;
  onCreateQuestionnaire: () => void;
  onSearch: (query: string) => void;
  showCreateQuestionnaireButton: boolean;
};

export const ContactDetailsOmniRiskProfileHeader: React.FC<ContactDetailsOmniRiskProfileHeaderProps> = ({
  firstName,
  omniRiskProfiles,
  query,
  searching,
  onCreateQuestionnaire,
  onSearch,
  showCreateQuestionnaireButton,
}) => (
  <div className="contact-details-risk-profiles-header">
    <h3 className="contact-details-comparisons-header-title">
      <FormattedMessage
        data-private
        data-dd-privacy="mask"
        id="Contacts.ContactTabs.RiskProfiles.Header"
        values={{ name: truncateString(firstName ?? '', 80) }}
      />
    </h3>

    <div className="content-actions">
      {!!omniRiskProfiles?.length && (
        <>
          <SearchInput
            className="search-input-v2"
            loading={searching}
            placeholder={formatMessage('Contacts.ContactTabs.RiskProfiles.SearchPlaceholder')}
            value={query}
            onChange={onSearch}
          />
          {showCreateQuestionnaireButton && (
            <Button variant="primary" icon="add" onClick={onCreateQuestionnaire}>
              <FormattedMessage id="OmniRiskProfilesTable.CreateQuestionnaire" />
            </Button>
          )}
        </>
      )}
    </div>
  </div>
);
